import React from 'react';
import { SunArcs } from './SunArcs';
import { AcroStack } from './AcroStack';
const lanes = [{
  name: 'Ground',
  tag: 'Day one',
  body: 'On the floor or in partner yoga. Builds shape, trust and strength with no height — nobody sits out.',
  card: 'bg-ground-soft',
  dot: 'bg-ground',
  text: 'text-ground-deep'
}, {
  name: 'Lift',
  tag: 'Standard',
  body: 'The L-base version. Spotter position, contact points and the way down written for every pose.',
  card: 'bg-lift-soft',
  dot: 'bg-lift',
  text: 'text-lift-deep'
}, {
  name: 'Fly',
  tag: 'Ready for more',
  body: 'The advanced or transition version, for pairs with experience — always with a spotter in place.',
  card: 'bg-fly-soft',
  dot: 'bg-fly',
  text: 'text-fly-deep'
}];
const blocks = [{
  time: '10 min',
  name: 'Connect',
  body: 'Warm-up and partner check-in, with the exact words to say.',
  dot: 'bg-lift'
}, {
  time: '15 min',
  name: 'Build',
  body: 'The skill of the day, step by step, with short cues in all three lanes.',
  dot: 'bg-ground'
}, {
  time: '20 min',
  name: 'Fly',
  body: 'Pairs and trios work their lane: spotter placed, way down rehearsed.',
  dot: 'bg-fly'
}, {
  time: '10 min',
  name: 'Play',
  body: 'A drill or game with exact reps, timing and role rotation — odd numbers solved.',
  dot: 'bg-coral'
}, {
  time: '5 min',
  name: 'Land',
  body: 'Cool-down and closing circle, script included, so they come back next week.',
  dot: 'bg-saffron'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="arcs-dark relative w-full overflow-hidden border-y-4 border-coral bg-night" data-id="element-261" data-mp="111zxxpum1znn">
      <SunArcs className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 text-saffron/15" data-id="element-262" data-mp="2ci6s28w2exb5" />
      <div className="relative mx-auto max-w-5xl px-5 py-14 sm:py-20" data-id="element-263" data-mp="2hgrjpjx948nz">
        <div className="text-center" data-id="element-264" data-mp="2hiuiotgdtc4u">
          <p className="eyebrow text-saffron" data-id="element-265" data-mp="1rs2wdyj6fk9w">The mechanism</p>
          <h2 id="mechanism-heading" className="lane-underline mt-3 font-display text-[30px] leading-tight text-sand sm:text-5xl" data-id="element-266" data-mp="1rup4q0dw63t6">
            The 3-Lane Spot Plan
          </h2>
          <p className="field-note mt-5 text-[28px] leading-tight text-sand sm:text-3xl" data-id="element-267" data-mp="1wryyfs8bd1mt">
            One plan. Three lanes. Every level in the room.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-base text-sand/80 sm:text-lg" data-id="element-268" data-mp="192nuk1vo2r4g">
            Every skill in the pack is written in three lanes that run at the
            same time, inside the same session. Each lane brings its own spot
            and its own way down — so one plan works for mixed levels, odd
            numbers and nervous students, without rewriting it at the last
            minute.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md rounded-[28px] bg-sand p-4 shadow-card" data-id="element-269" data-mp="ld1xbjyuulz3">
          <AcroStack className="h-auto w-full" data-id="element-270" data-mp="2x05h4z31zmsh" />
          <ul className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-bold uppercase tracking-wider text-night-soft" data-id="element-271" data-mp="2wzdjlipwbezk">
            <li className="flex items-center gap-1.5" data-id="element-272" data-mp="31sovhy9kelyc"><span className="h-2.5 w-2.5 rounded-full bg-night" data-id="element-273" data-mp="2n2r2n50ox82t" />Base</li>
            <li className="flex items-center gap-1.5" data-id="element-274" data-mp="2s0suaec6mfpw"><span className="h-2.5 w-2.5 rounded-full bg-coral" data-id="element-275" data-mp="2s1u8grohvibu" />Flyer</li>
            <li className="flex items-center gap-1.5" data-id="element-276" data-mp="3fqdet1nzhl1a"><span className="h-2.5 w-2.5 rounded-full border-2 border-saffron" data-id="element-277" data-mp="3frg3r41qxdek" />Spotter</li>
            <li className="flex items-center gap-1.5" data-id="element-278" data-mp="3kp7xm3lyb9le"><span className="h-1 w-4 rounded-full bg-ground" data-id="element-279" data-mp="36pyp7q3zljrz" />Way down</li>
          </ul>
        </div>

        <div className="mx-auto mt-6 grid max-w-3xl gap-3 sm:grid-cols-3" data-id="element-280" data-mp="3araa5ibx1gtu">
          {lanes.map(lane => <div key={lane.name} className={`rounded-2xl px-4 py-4 text-night ${lane.card}`} data-id="element-281" data-mp="1vaa3t36dssta">
              <div className="flex items-center justify-between gap-2" data-id="element-282" data-mp="1zcwpemcglhi1">
                <span className="flex items-center gap-2 font-display text-lg" data-id="element-283" data-mp="1za26iz93g4qq">
                  <span className={`h-4 w-4 rounded-full ${lane.dot}`} aria-hidden="true" data-id="element-284" data-mp="2fkukl94w6hjy" />
                  {lane.name}
                </span>
                <span className={`text-[10px] font-extrabold uppercase tracking-widest ${lane.text}`} data-id="element-285" data-mp="25t6v3drwbal4">
                  {lane.tag}
                </span>
              </div>
              <p className="mt-1.5 text-sm leading-snug text-night-soft" data-id="element-286" data-mp="20sspe2drocq9">{lane.body}</p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-287" data-mp="2tj17xvc7sz5d">
          <h3 className="font-display text-2xl text-sand sm:text-3xl" data-id="element-288" data-mp="2tk3vbtabwjgj">
            Every session runs on the{' '}
            <span className="text-coral" data-id="element-289" data-mp="2om2elf0dkw88">Connect-Build-Fly-Play-Land</span>{' '}
            Formula
          </h3>
          <p className="mx-auto mt-2 max-w-xl text-[15px] text-sand/75" data-id="element-290" data-mp="1d52p0r5ewvhw">
            Same five blocks in all 60 sessions, so after two weeks you teach it
            from memory. Versions for 45, 60 and 90 minutes.
          </p>
        </div>

        <ol className="relative mx-auto mt-7 max-w-2xl" data-id="element-291" data-mp="3ks439m0r8iqq">
          <span aria-hidden="true" className="absolute bottom-6 left-[19px] top-6 border-l-2 border-dashed border-sand/25" data-id="element-292" data-mp="3os4te3x7uidm" />
          {blocks.map((block, i) => <li key={block.name} className="relative flex gap-4 pb-4 last:pb-0" data-id="element-293" data-mp="2cjr3264mm80" data-mpi={i}>
              <span className={`relative z-10 flex h-10 w-10 flex-none items-center justify-center rounded-full font-display text-sm text-night ring-4 ring-night ${block.dot}`} data-id="element-294" data-mp="2eo6ag9h77nl">
                {i + 1}
              </span>
              <div className="flex-1 rounded-2xl border border-sand/10 bg-sand/[0.06] px-4 py-3" data-id="element-295" data-mp="gdnqnbpyh0dy">
                <div className="flex flex-wrap items-baseline justify-between gap-x-3" data-id="element-296" data-mp="lamj7ptz0za1">
                  <span className="font-display text-lg text-sand" data-id="element-297" data-mp="2i4r2g4bl0l03">
                    {block.name}
                  </span>
                  <span className="text-[11px] font-bold uppercase tracking-widest text-saffron" data-id="element-298" data-mp="2n3kio4i96q3y">
                    {block.time}
                  </span>
                </div>
                <p className="mt-1 text-sm leading-snug text-sand/80" data-id="element-299" data-mp="3lfwwud442ofh">
                  {block.body}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}